import { PaxCheckChecklistItemStatus } from "../../../api";

enum ChecklistItemStatus {
  NotYetResolved = "not-yet-resolved",
  VerificationRequired = "verification-required",
  Resolved = "resolved",
}

export function ChecklistItemStatusFromApi(
  status: PaxCheckChecklistItemStatus
): ChecklistItemStatus {
  switch (status) {
    case PaxCheckChecklistItemStatus.NOT_YET_RESOLVED:
      return ChecklistItemStatus.NotYetResolved;
    case PaxCheckChecklistItemStatus.RESOLVED:
      return ChecklistItemStatus.Resolved;
    case PaxCheckChecklistItemStatus.VERIFICATION_REQUIRED:
      return ChecklistItemStatus.VerificationRequired;
  }
}

export default ChecklistItemStatus;
